import { render, staticRenderFns } from "./TableContainerWebDraft.vue?vue&type=template&id=661d6ae0"
import script from "./TableContainerWebDraft.vue?vue&type=script&lang=js"
export * from "./TableContainerWebDraft.vue?vue&type=script&lang=js"
import style0 from "./TableContainerWebDraft.vue?vue&type=style&index=0&id=661d6ae0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports